// 099 运营后台 · 数据获取 hook：loading / 403 / error 三态封装（沿用 Admin.tsx 模式）
import { useCallback, useEffect, useState } from "react";
import { ApiError } from "../../lib/api";

export interface OpsQueryState<T> {
  data: T | null;
  loading: boolean;
  forbidden: string | null; // 403：未授权（Layout 层通常已拦截，这里兜底）
  error: string | null;
  reload: () => void;
}

export function useOpsQuery<T>(fetcher: () => Promise<T>, deps: unknown[] = []): OpsQueryState<T> {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [forbidden, setForbidden] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const run = useCallback(fetcher, deps);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    run()
      .then((d) => setData(d))
      .catch((e) => {
        if (e instanceof ApiError && e.status === 403) setForbidden(e.message);
        else setError((e as Error).message);
      })
      .finally(() => setLoading(false));
  }, [run]);

  useEffect(() => { load(); }, [load]);
  return { data, loading, forbidden, error, reload: load };
}
